<template>
    <div>
        <v-container>
            <v-row no-gutters>
                <v-col :cols="6">
                    <h1 class="headline font-weight-light mb-3">IT Services</h1>
                </v-col>
                <v-col :cols="6" class="text-right"></v-col>
            </v-row>
        </v-container>
        <v-dialog v-model="dialogimg" max-width="1000px">
            <v-card>
                <v-card-title>
                    <span class="headline">Img :</span>
                </v-card-title>
                <v-card-text>
                    <v-container></v-container>
                </v-card-text>

                <div
                    v-for="(itemeditpic, idxeditpic) in editedItem.images"
                    :key="idxeditpic"
                >
                    <div style="margin-left: 80%; font-size: 50px">
                        <button
                            type="button"
                            @click="
                                deletepic(
                                    itemeditpic.file_store_name,
                                    editedItem,
                                    itemeditpic
                                )
                            "
                        >
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div v-viewer class="images clearfix">
                        <img
                            style="
                                margin-left: 25%;
                                max-width: 50%;
                                max-height: 50%;
                            "
                            :src="showpic + itemeditpic.file_store_name"
                            class="image"
                        />
                    </div>
                </div>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="cancelimg()"
                        >Cancel</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-form ref="form" method="post" id="nativeForm" v-model="valid">
            <v-dialog v-model="dialog" max-width="1000px">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>

                        <v-autocomplete
                            v-if="team_name == 'PROGRAMMER'"
                            style="margin-left: 60px"
                            v-model="editedItem.created_by"
                            :items="employees"
                            filled
                            chips
                            color="blue-grey lighten-2"
                            label="Request Ticket"
                            :item-text="
                                (item) =>
                                    item.branch_name +
                                    ' - ' +
                                    item.emp_id +
                                    ' - ' +
                                    item.emp_name_en +
                                    ' - ' +
                                    item.emp_surname_en
                            "
                            item-value="emp_id"
                        >
                            <template v-slot:selection="data">
                                <v-chip
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    close
                                    @click="data.select"
                                    @click:close="remove()"
                                >
                                    {{ data.item.emp_id }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template>
                                    <div style="font-weight: bold">
                                        <label
                                            >({{ data.item.branch_name }})
                                            {{ data.item.emp_id }}
                                            {{ data.item.emp_name_en }}
                                            {{
                                                data.item.emp_surname_en
                                            }}</label
                                        >
                                    </div>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <center>
                                <v-row>
                                    <div
                                        v-for="(item, idx) in datait"
                                        :key="idx"
                                        style="margin-left: 10px"
                                    >
                                        <button
                                            @click="selected(item.problem_id)"
                                            :class="button[item.problem_id]"
                                        >
                                            <v-icon
                                                v-if="
                                                    button[item.problem_id] ==
                                                    'button'
                                                "
                                                style="color: black"
                                                >{{ item.icon }}</v-icon
                                            >
                                            <v-icon
                                                v-if="
                                                    button[item.problem_id] ==
                                                    'button1'
                                                "
                                                style="color: white"
                                                >{{ item.icon }}</v-icon
                                            >
                                        </button>
                                        <br />
                                        <br />
                                        <h3>{{ item.problem_name }}</h3>
                                        <br />
                                    </div>
                                </v-row>
                            </center>
                            <v-alert
                                type="info"
                                v-if="
                                    editedItem.problem_id != 1 &&
                                    editedItem.problem_id != 2 &&
                                    editedItem.problem_id != '' &&
                                    editedItem.problem_id != 7
                                "
                            >
                                <v-row style="text-align: left">
                                    Subproblem
                                </v-row>
                            </v-alert>
                            <v-row style="margin-top: 20px">
                                <div
                                    cols="12"
                                    sm="6"
                                    md="3"
                                    v-if="
                                        editedItem.problem_id != 1 &&
                                        editedItem.problem_id != 2 &&
                                        editedItem.problem_id != '' &&
                                        editedItem.problem_id != 7
                                    "
                                    v-for="(items, idx) in subproblems"
                                    :key="idx"
                                    style="margin-left: 10px"
                                >
                                    <button
                                        @click="
                                            selectedsubname(items.subproblem_id)
                                        "
                                        :class="buttonsub[items.subproblem_id]"
                                    >
                                        <v-icon
                                            v-if="
                                                buttonsub[
                                                    items.subproblem_id
                                                ] == 'buttonsub'
                                            "
                                            style="color: black"
                                            >{{ items.icon }}</v-icon
                                        >
                                        <v-icon
                                            v-if="
                                                buttonsub[
                                                    items.subproblem_id
                                                ] == 'buttonsub1'
                                            "
                                            style="color: white"
                                            >{{ items.icon }}</v-icon
                                        >
                                    </button>

                                    <br />
                                    <br />
                                    <h4 style="text-align: center">
                                        {{ items.subproblem_name }}
                                    </h4>
                                </div>

                                <!-- <v-col
                  cols="12"
                  sm="6"
                  md="2"
                  v-if="
                    editedItem.problem_id != 1 &&
                      editedItem.problem_id != 2 &&
                      editedItem.problem_id != '' &&
                      editedItem.problem_id != 7
                  "
                >
                  <v-select
                    v-model="editedItem.subproblem_id"
                    :items="subproblems"
                    item-text="subproblem_name"
                    item-value="subproblem_id"
                    menu-props="auto"
                    label="Type/ประเภทของงาน"
                    hide-details
                    single-line
                    :rules="TypeR"
                    required
                  ></v-select>
                </v-col> -->
                                <v-col
                                    cols="12"
                                    sm="3"
                                    md="3"
                                    v-if="
                                        editedItem.problem_id == 6 &&
                                        editedItem.problem_id != ''
                                    "
                                >
                                    <v-text-field
                                        outlined
                                        label="ReceiptNo"
                                        append-icon="mdi-receipt"
                                        v-model="editedItem.receipt_no"
                                        :rules="ReceiptnoR"
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="3"
                                    md="4"
                                    v-if="
                                        editedItem.problem_id == 6 &&
                                        editedItem.problem_id != ''
                                    "
                                >
                                    <v-text-field
                                        outlined
                                        label="CaseID"
                                        append-icon="mdi-file-question"
                                        :rules="CaseIDR"
                                        v-model="editedItem.case_id"
                                        required
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <br />
                            <v-row>
                                <v-col cols="12" md="12" sm="12">
                                    <v-textarea
                                        outlined
                                        name="input-7-4"
                                        v-model="editedItem.detail"
                                        :rules="DescriptionR"
                                        required
                                        label="Description of Problem / รายละเอียดของปัญหา"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                            <form>
                                <v-row>
                                    <v-col cols="12" sm="6" md="4">
                                        <template>
                                            <v-file-input
                                                color="blue darken-4"
                                                counter
                                                label="Attach files (optional) / แนบไฟล์ (ถ้ามี)"
                                                multiple
                                                placeholder="Select your files"
                                                prepend-icon="mdi-paperclip"
                                                v-model="files"
                                                :show-size="1000"
                                                @change="onFileSelected"
                                            >
                                                <template
                                                    v-slot:selection="{
                                                        index,
                                                        text,
                                                    }"
                                                >
                                                    <v-chip
                                                        v-if="index < 2"
                                                        color="blue accent-4"
                                                        dark
                                                        label
                                                        small
                                                        >{{ text }}</v-chip
                                                    >

                                                    <span
                                                        v-else-if="index === 2"
                                                        class="overline grey--text text--darken-3 mx-2"
                                                    >
                                                        +{{ files.length - 2 }}
                                                        File(s)
                                                    </span>
                                                </template>
                                            </v-file-input>
                                        </template>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="8">
                                        <v-chip
                                            v-for="(
                                                itemeditpic3, idxeditpic3
                                            ) in editedItem.images"
                                            :key="idxeditpic3"
                                            close
                                            @click:close="
                                                deletepic(
                                                    itemeditpic3.file_store_name,
                                                    editedItem,
                                                    itemeditpic3
                                                )
                                            "
                                            small
                                            class="mr-2 mb-2"
                                            :href="
                                                showpic +
                                                itemeditpic3.file_store_name +
                                                '/' +
                                                itemeditpic3.file_name
                                            "
                                            target="_blank"
                                        >
                                            <v-avatar left>
                                                <v-icon small
                                                    >mdi-paperclip</v-icon
                                                > </v-avatar
                                            >{{ itemeditpic3.file_name }}
                                        </v-chip>

                                        <v-chip
                                            v-for="(
                                                itemeditpic2, idxeditpic2
                                            ) in editedItem.files"
                                            :key="idxeditpic2"
                                            close
                                            @click:close="
                                                deletefiles(
                                                    itemeditpic2.file_store_name,
                                                    editedItem,
                                                    itemeditpic2
                                                )
                                            "
                                            small
                                            class="mr-2 mb-2"
                                            :href="
                                                showpic +
                                                itemeditpic2.file_store_name +
                                                '/' +
                                                itemeditpic2.file_name
                                            "
                                            target="_blank"
                                        >
                                            <v-avatar left>
                                                <v-icon small
                                                    >mdi-paperclip</v-icon
                                                > </v-avatar
                                            >{{ itemeditpic2.file_name }}
                                        </v-chip>

                                        <!-- <v-chip
                      close
                      v-for="(itemeditpic, idxeditpic) in editedItem.files"
                      :key="idxeditpic"
                      @click:close="
                        deletepic(
                          itemeditpic.file_store_name,
                          editedItem,
                          itemeditpic
                        )
                      "
                      small
                      class="mr-2 mb-2"
                      @click="showimg()"
                    >
                      <v-avatar left>
                        <v-icon small>mdi-paperclip</v-icon>
                      </v-avatar>
                      {{ itemeditpic.file_name }}
                    </v-chip>-->
                                    </v-col>
                                </v-row>
                            </form>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close"
                            >Cancel</v-btn
                        >
                        <v-btn
                            v-if="
                                checkbutton &&
                                editedItem.problem_id != 3 &&
                                editedItem.problem_id != 4 &&
                                editedItem.problem_id != 5 &&
                                editedItem.problem_id != 6
                            "
                            color="blue darken-1"
                            text
                            @click="save"
                            :disabled="!valid"
                            rounded
                            >Save</v-btn
                        >
                        <v-btn
                            v-if="
                                checkbutton &&
                                checkbuttonsub &&
                                (editedItem.problem_id == 3 ||
                                    editedItem.problem_id == 4 ||
                                    editedItem.problem_id == 5 ||
                                    editedItem.problem_id == 6)
                            "
                            color="blue darken-1"
                            text
                            @click="save"
                            :disabled="!valid"
                            rounded
                            >Save</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-form>

        <v-form
            ref="formviewit"
            method="post"
            id="nativeFormit"
            v-model="validit"
        >
            <v-dialog v-model="dialogviewit" max-width="1000px">
                <v-card>
                    <center>
                        <v-card-title>
                            <div>
                                <!-- <span class="headline">View ItServices</span> -->
                            </div>
                        </v-card-title>
                    </center>
                    <v-card-text>
                        <v-container>
                            <v-row class="mar-2">
                                <v-col cols="12" sm="6" md="6">
                                    <div>
                                        <label
                                            style="
                                                font-size: 16px;
                                                color: black;
                                                font-weight: bold;
                                            "
                                            >Ticket :</label
                                        >

                                        <label
                                            style="
                                                font-size: 15px;
                                                color: black;
                                            "
                                            >{{ viewItem.ticket_id }}</label
                                        >
                                        <label class="status1">
                                            <br />
                                        </label>
                                        <label
                                            class="status"
                                            style="
                                                font-size: 16px;
                                                color: black;
                                                font-weight: bold;
                                                white-space: nowrap;
                                            "
                                            >Status :</label
                                        >

                                        <v-chip
                                            v-if="viewItem.status == 'open'"
                                            class="white--text mr-1 ml-1"
                                            color="primary"
                                            text-color="white"
                                            small
                                            right
                                        >
                                            <v-avatar left>
                                                <v-icon>mdi-email-open</v-icon>
                                            </v-avatar>
                                            {{ viewItem.status }}
                                        </v-chip>
                                        <v-chip
                                            v-if="viewItem.status == 'approve'"
                                            class="white--text mr-1 ml-1"
                                            color="warning"
                                            text-color="white"
                                            small
                                        >
                                            <v-avatar left>
                                                <v-icon
                                                    >mdi-account-multiple</v-icon
                                                >
                                            </v-avatar>
                                            {{ viewItem.status }}
                                        </v-chip>
                                        <v-chip
                                            v-if="
                                                viewItem.status == 'not approve'
                                            "
                                            class="white--text mr-1 ml-1"
                                            color="grey"
                                            text-color="white"
                                            small
                                        >
                                            <v-avatar left>
                                                <v-icon>mdi-account-off</v-icon>
                                            </v-avatar>
                                            {{ viewItem.status }}
                                        </v-chip>

                                        <v-chip
                                            v-if="viewItem.status == 'response'"
                                            class="white--text mr-1 ml-1"
                                            color="red"
                                            text-color="white"
                                            small
                                        >
                                            <v-avatar left>
                                                <v-icon
                                                    >mdi-account-convert</v-icon
                                                >
                                            </v-avatar>
                                            {{ viewItem.status }}
                                        </v-chip>
                                        <v-chip
                                            v-if="viewItem.status == 'closed'"
                                            class="white--text mr-1 ml-1"
                                            color="success"
                                            text-color="white"
                                            small
                                        >
                                            <v-avatar left>
                                                <v-icon
                                                    >mdi-close-outline</v-icon
                                                >
                                            </v-avatar>
                                            {{ viewItem.status }}
                                        </v-chip>
                                    </div>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <label
                                        style="
                                            font-size: 16px;
                                            color: black;
                                            font-weight: bold;
                                            white-space: nowrap;
                                        "
                                        >Created :</label
                                    >
                                    <label
                                        style="font-size: 15px; color: black"
                                        >{{ viewItem.created_date }}</label
                                    >&nbsp;
                                    <label
                                        style="font-size: 15px; color: black"
                                        >{{ viewItem.created_name }}</label
                                    >
                                    ( {{ viewItem.created_by }} )
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="6">
                                    <label
                                        style="
                                            font-size: 16px;
                                            color: black;
                                            font-weight: bold;
                                            white-space: nowrap;
                                        "
                                        >Response :</label
                                    >
                                    <label
                                        style="font-size: 15px; color: black"
                                        >{{ typeviewit.responsed_at }}</label
                                    >&nbsp;
                                    <label
                                        style="font-size: 15px; color: black"
                                        >{{ typeviewit.responsed_name }}</label
                                    >
                                    ( {{ typeviewit.responsed_by }} )
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <label
                                        style="
                                            font-size: 16px;
                                            color: black;
                                            font-weight: bold;
                                            white-space: nowrap;
                                        "
                                        >Closed :</label
                                    >
                                    <label
                                        style="font-size: 15px; color: black"
                                        >{{ typeviewit.closed_at }}</label
                                    >&nbsp;
                                    <label
                                        style="font-size: 15px; color: black"
                                        >{{ typeviewit.closed_name }}</label
                                    >
                                    ( {{ typeviewit.closed_by }} )
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="6">
                                    <label
                                        style="
                                            font-size: 16px;
                                            color: black;
                                            font-weight: bold;
                                            white-space: nowrap;
                                        "
                                        >Approved Group :</label
                                    >
                                    <label
                                        style="font-size: 15px; color: black"
                                        >{{ typeviewit.approve_name }}</label
                                    >
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <label
                                        style="
                                            font-size: 16px;
                                            color: black;
                                            font-weight: bold;
                                            white-space: nowrap;
                                        "
                                        >Approved :</label
                                    >
                                    <label
                                        style="font-size: 15px; color: black"
                                        >{{ typeviewit.approved_name }}</label
                                    >&nbsp;
                                    <label
                                        style="font-size: 15px; color: black"
                                        >{{ typeviewit.approved_at }}</label
                                    >
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="6">
                                    <label
                                        style="
                                            font-size: 16px;
                                            color: black;
                                            font-weight: bold;
                                            white-space: nowrap;
                                        "
                                        >Problem :</label
                                    >
                                    <label
                                        style="font-size: 15px; color: black"
                                        >{{ viewItem.problem_name }}</label
                                    >

                                    <v-label>/</v-label>
                                    <label
                                        style="font-size: 15px; color: black"
                                        >{{ viewItem.subproblem_name }}</label
                                    >
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <label
                                        style="
                                            font-size: 16px;
                                            color: black;
                                            font-weight: bold;
                                            white-space: nowrap;
                                        "
                                        >Type :</label
                                    >
                                    <label
                                        style="font-size: 15px; color: black"
                                        >{{ typeviewit.error_name }}</label
                                    >
                                </v-col>
                            </v-row>
                            <v-row
                                v-if="
                                    viewItem.problem_id == 6 ||
                                    typeviewit.problem_id == 6
                                "
                            >
                                <v-col cols="12" sm="6" md="6">
                                    <label
                                        style="
                                            font-size: 16px;
                                            color: black;
                                            font-weight: bold;
                                            white-space: nowrap;
                                        "
                                        >ReceiptNO :</label
                                    >
                                    <label
                                        style="font-size: 15px; color: black"
                                        >{{ viewItem.receipt_no }}</label
                                    >
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <label
                                        style="
                                            font-size: 16px;
                                            color: black;
                                            font-weight: bold;
                                            white-space: nowrap;
                                        "
                                        >CaseID :</label
                                    >
                                    <label
                                        style="font-size: 15px; color: black"
                                        >{{ viewItem.case_id }}</label
                                    >
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="6">
                                    <label
                                        style="
                                            font-size: 16px;
                                            color: black;
                                            font-weight: bold;
                                            white-space: nowrap;
                                        "
                                        >Detail :</label
                                    >
                                    <label
                                        style="font-size: 15px; color: black"
                                        >{{ viewItem.detail }}</label
                                    >
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <label
                                        style="
                                            font-size: 16px;
                                            color: black;
                                            font-weight: bold;
                                            white-space: nowrap;
                                        "
                                        >Severity :</label
                                    >
                                    <label
                                        style="font-size: 15px; color: black"
                                        >{{ viewItem.severity }}</label
                                    >
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="6">
                                    <label
                                        style="
                                            font-size: 16px;
                                            color: black;
                                            font-weight: bold;
                                            white-space: nowrap;
                                        "
                                        >type :</label
                                    >
                                    <label
                                        style="font-size: 15px; color: black"
                                        >{{ viewItem.type }}</label
                                    >
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <label
                                        style="
                                            font-size: 16px;
                                            color: black;
                                            font-weight: bold;
                                            white-space: nowrap;
                                        "
                                        >Cause :</label
                                    >
                                    <label
                                        style="font-size: 15px; color: black"
                                        >{{ viewItem.cause }}</label
                                    >
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="6">
                                    <label
                                        style="
                                            font-size: 16px;
                                            color: black;
                                            font-weight: bold;
                                            white-space: nowrap;
                                        "
                                        >solution :</label
                                    >
                                    <label
                                        style="font-size: 15px; color: black"
                                        >{{ viewItem.solution }}</label
                                    >
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="6">
                                    <v-container fluid>
                                        <v-row v-viewer>
                                            <v-col
                                                v-for="(
                                                    itemeditpic, idxeditpic
                                                ) in typeviewit.images"
                                                :key="idxeditpic"
                                                cols="2"
                                            >
                                                <img
                                                    class="images"
                                                    :src="
                                                        showpic +
                                                        itemeditpic.file_store_name +
                                                        '/' +
                                                        itemeditpic.file_name
                                                    "
                                                    width="100%"
                                                />
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-chip
                                        v-for="(
                                            itemeditpic2, idxeditpic2
                                        ) in typeviewit.files"
                                        :key="idxeditpic2"
                                        small
                                        class="mr-2 mb-2"
                                        :href="
                                            showpic +
                                            itemeditpic2.file_store_name +
                                            '/' +
                                            itemeditpic2.file_name
                                        "
                                        target="_blank"
                                    >
                                        <v-avatar left>
                                            <v-icon small
                                                >mdi-paperclip</v-icon
                                            > </v-avatar
                                        >{{ itemeditpic2.file_name }}
                                    </v-chip>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col
                                    v-if="viewItem.status == 'approve'"
                                    sm="12"
                                    md="6"
                                    lg="6"
                                    xl="6"
                                >
                                    <button
                                        @click="selected1(1)"
                                        :class="button2[1]"
                                    >
                                        <div v-if="button2[1] == 'button4'">
                                            <v-icon style="color: black"
                                                >mdi-account-check</v-icon
                                            >
                                            <label style="color: black"
                                                >Approve</label
                                            >
                                        </div>
                                        <div v-if="button2[1] == 'button5'">
                                            <v-icon style="color: white"
                                                >mdi-account-check</v-icon
                                            >
                                            <label style="color: white"
                                                >Approve</label
                                            >
                                        </div>
                                    </button>
                                    <!-- <v-btn
                    style="margin-left:15px"
                    @click="
                      (typeapproveh = 2), (typeapprovenameh = 'Not Approve')
                    "
                    color="error"
                    fab
                    dark
                  >
                    <v-icon>mdi-account-remove</v-icon>
                  </v-btn>-->
                                    <button
                                        @click="selected1(2)"
                                        :class="button2[2]"
                                    >
                                        <div v-if="button2[2] == 'button4'">
                                            <v-icon style="color: black"
                                                >mdi-account-remove</v-icon
                                            >
                                            <label style="color: black"
                                                >Not Approve</label
                                            >
                                        </div>
                                        <div v-if="button2[2] == 'button5'">
                                            <v-icon style="color: white"
                                                >mdi-account-remove</v-icon
                                            >
                                            <label style="color: white"
                                                >Not Approve</label
                                            >
                                        </div>
                                    </button>
                                </v-col>
                                <v-col
                                    v-if="
                                        viewItem.status == 'approve' &&
                                        typeapproveh == 2
                                    "
                                    sm="12"
                                    md="6"
                                    lg="6"
                                    xl="6"
                                >
                                    <v-form
                                        method="post"
                                        id="nativeFormApprove"
                                        v-model="validapprove"
                                    >
                                        <v-textarea
                                            v-model="sentviewItresponse.remark"
                                            outlined
                                            name="input-7-4"
                                            label="เหตุผลที่ไม่อนุมัติ/not approve"
                                            :rules="notapproveR"
                                            required
                                        ></v-textarea>
                                    </v-form>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <v-select
                                        v-if="
                                            viewItem.status == 'open' &&
                                            viewItem.problem_id != '2' &&
                                            (viewItem.problem_id != '8') &
                                                (team_name == 'PROGRAMMER')
                                        "
                                        v-model="sentviewIt.severity"
                                        :items="SeveritySelect"
                                        menu-props="auto"
                                        label="Severity"
                                        hide-details
                                        single-line
                                        dense
                                        outlined
                                        :rules="SeverityR"
                                        required
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-select
                                        v-if="
                                            viewItem.status == 'open' &&
                                            viewItem.problem_id != '2' &&
                                            (viewItem.problem_id != '8') &
                                                (team_name == 'PROGRAMMER')
                                        "
                                        v-model="sentviewIt.type"
                                        :items="TypeSelect"
                                        menu-props="auto"
                                        label="ประเภทของงาน"
                                        hide-details
                                        single-line
                                        dense
                                        outlined
                                        :rules="TypeitR"
                                        required
                                    ></v-select>
                                </v-col>
                                <v-col>
                                    <v-select
                                        v-if="
                                            viewItem.status == 'open' &&
                                            viewItem.problem_id != '2' &&
                                            (viewItem.problem_id != '8') &
                                                (team_name == 'PROGRAMMER')
                                        "
                                        v-model="sentviewIt.error_id"
                                        :items="typeviewit.error_list"
                                        item-text="error_name"
                                        item-value="error_id"
                                        menu-props="auto"
                                        label="Error"
                                        hide-details
                                        single-line
                                        dense
                                        outlined
                                        :rules="ErrorR"
                                        required
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-form
                                method="post"
                                id="nativeFormresponse"
                                v-model="validresponse"
                            >
                                <v-row
                                    v-if="
                                        viewItem.status == 'response' &&
                                        team_name == 'PROGRAMMER'
                                    "
                                >
                                    <v-col cols="12" sm="6" md="4">
                                        <v-textarea
                                            outlined
                                            name="input-7-4"
                                            label="วิธีการแก้ไข/ปัญหา"
                                            :rules="ResponeR"
                                            v-model="sentviewItresponse.remark"
                                            required
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-textarea
                                            outlined
                                            name="input-7-4"
                                            label="สาเหตุของปัญหา"
                                            :rules="CauseR"
                                            v-model="sentviewItresponse.cause"
                                            required
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-textarea
                                            outlined
                                            name="input-7-4"
                                            label="วิธีการป้องกันไม่ให้เกิดปัญหา"
                                            :rules="SolutionR"
                                            v-model="
                                                sentviewItresponse.solution
                                            "
                                            required
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col
                                        v-if="
                                            viewItem.status == 'response' &&
                                            team_name == 'PROGRAMMER'
                                        "
                                    >
                                        <template>
                                            <v-file-input
                                                color="blue darken-4"
                                                counter
                                                label="Attach files (optional) / แนบไฟล์ (ถ้ามี)"
                                                multiple
                                                v-model="
                                                    sentviewItresponse.files
                                                "
                                                placeholder="Select your files"
                                                prepend-icon="mdi-paperclip"
                                                :show-size="1000"
                                                @change="onFileSelected"
                                            >
                                                <template
                                                    v-slot:selection="{
                                                        index,
                                                        text,
                                                    }"
                                                >
                                                    <v-chip
                                                        v-if="index < 2"
                                                        color="blue accent-4"
                                                        dark
                                                        label
                                                        small
                                                        >{{ text }}</v-chip
                                                    >

                                                    <span
                                                        v-else-if="index === 2"
                                                        class="overline grey--text text--darken-3 mx-2"
                                                    >
                                                        +{{ files.length - 2 }}
                                                        File(s)
                                                    </span>
                                                </template>
                                            </v-file-input>
                                        </template>
                                    </v-col>
                                </v-row>
                                <v-row v-if="typeviewit.status == 'closed'">
                                    <v-col cols="12" sm="12" md="12">
                                        <label
                                            style="
                                                font-size: 16px;
                                                color: black;
                                                font-weight: bold;
                                                white-space: nowrap;
                                            "
                                            >ProgrammerRespone :</label
                                        >
                                        <label
                                            style="
                                                font-size: 15px;
                                                color: black;
                                            "
                                            >{{ typeviewit.remark }}</label
                                        >
                                    </v-col>
                                </v-row>
                            </v-form>

                            <v-row>
                                <v-col
                                    sm="12"
                                    md="6"
                                    lg="6"
                                    xl="6"
                                    v-if="team_name == 'PROGRAMMER'"
                                >
                                    <button
                                        v-if="viewItem.status == 'open'"
                                        @click="selectedn(1)"
                                        :class="button1[1]"
                                    >
                                        <div v-if="button1[1] == 'button2'">
                                            <v-icon style="color: black"
                                                >mdi-account-check</v-icon
                                            >
                                            <label style="color: black"
                                                >Need Approve</label
                                            >
                                        </div>
                                        <div v-if="button1[1] == 'button3'">
                                            <v-icon style="color: white"
                                                >mdi-account-check</v-icon
                                            >
                                            <label style="color: white"
                                                >Need Approve</label
                                            >
                                        </div>
                                    </button>
                                    <!-- Need Approve -->
                                    <button
                                        v-if="viewItem.status == 'open'"
                                        @click="selectedn(2)"
                                        :class="button1[2]"
                                    >
                                        <div v-if="button1[2] == 'button2'">
                                            <v-icon style="color: black"
                                                >mdi-checkbox-marked-circle</v-icon
                                            >
                                            <label style="color: black"
                                                >Respone</label
                                            >
                                        </div>
                                        <div v-if="button1[2] == 'button3'">
                                            <v-icon style="color: white"
                                                >mdi-checkbox-marked-circle</v-icon
                                            >
                                            <label style="color: white"
                                                >Respone</label
                                            >
                                        </div>
                                    </button>
                                </v-col>

                                <v-col
                                    sm="12"
                                    md="6"
                                    lg="6"
                                    xl="6"
                                    v-if="
                                        typeapprove != '' &&
                                        typeapprove != '2' &&
                                        viewItem.status == 'open'
                                    "
                                >
                                    <v-select
                                        v-model="sentviewIt.approve_id"
                                        :items="typeviewit.approve_list"
                                        item-text="approve_name"
                                        item-value="approve_id"
                                        menu-props="auto"
                                        label="Who Approve/คนอนุญาติคือใคร"
                                        hide-details
                                        single-line
                                        dense
                                        outlined
                                        :rules="SelectApproveR"
                                        required
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <!-- <v-btn
                v-if="viewItem.status == 'open'"
                cols="12"
                sm="6"
                md="4"
                class="white--text mr-1 ml-1"
                @click="(typeapprove = 2), (typeapprovename = 'Respone')"
                depressed
              >
                <v-icon dark>mdi-checkbox-marked-circle</v-icon>Respone
              </v-btn>-->
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeviewit"
                            >Cancel</v-btn
                        >

                        <v-btn
                            v-if="
                                typeapprove != '' && team_name == 'PROGRAMMER'
                            "
                            color="blue darken-1"
                            text
                            @click="saveit"
                            :disabled="!validit"
                            rounded
                            >Save</v-btn
                        >
                        <v-btn
                            v-if="
                                viewItem.status == 'approve' &&
                                typeapproveh != '' &&
                                typeapproveh == '1'
                            "
                            @click="saveitapprove"
                            :disabled="!validresponse"
                            color="blue darken-1"
                            text
                            >Save</v-btn
                        >
                        <v-btn
                            v-if="
                                viewItem.status == 'approve' &&
                                typeapproveh != '' &&
                                typeapproveh == '2'
                            "
                            @click="saveitapprove"
                            :disabled="!validapprove"
                            color="blue darken-1"
                            text
                            >Save</v-btn
                        >
                        <v-btn
                            v-if="
                                viewItem.status == 'response' &&
                                team_name == 'PROGRAMMER'
                            "
                            @click="saveitresponse"
                            :disabled="!validresponse"
                            color="blue darken-1"
                            text
                            >Save</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-form>

        <v-card>
            <v-card-title>
                <v-chip-group mandatory active-class="primary--text">
                    <v-chip @click="searchProject('')"> all </v-chip>
                    <v-chip @click="searchProject('open')"> open </v-chip>
                    <v-chip @click="searchProject('approve')">
                        wait approve
                    </v-chip>
                    <v-chip @click="searchProject('response')">
                        response
                    </v-chip>
                </v-chip-group>
                <v-spacer></v-spacer>
                <v-row>
                    <v-col md="6">
                        <v-text-field
                            label="Search"
                            v-model="form_search.search"
                            @input="getAjax()"
                        >
                        </v-text-field>
                    </v-col>
                    <v-col md="6">
                        <v-menu
                            v-model="modal"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="dateRangeText"
                                    label="Date range"
                                    readonly
                                    v-on="on"
                                    :rules="dateR"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                style="min-width: 0px !important; width: 420px"
                                v-model="form_search.date"
                                range
                                @change="get_date()"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>

                <v-btn color="primary" dark class="mb-2" @click="newItem()"
                    >Create New</v-btn
                >
            </v-card-title>

            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-center">
                                <b style="color: black">#</b>
                            </th>
                            <th class="text-center">
                                <b style="color: black">REQUEST</b>
                            </th>
                            <th class="text-center">
                                <b style="color: black">TYPE</b>
                            </th>
                            <th class="text-center">
                                <b style="color: black">STATUS</b>
                            </th>

                            <th class="text-center">
                                <b style="color: black">DETAIL</b>
                            </th>
                            <th class="text-center"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="items in data.data" :key="items.ticket_id">
                            <td class="text-center">{{ items.ticket_id }}</td>
                            <td class="text-center">
                                {{ items.created_date }}
                                <br />
                                {{ items.created_name }}
                                <br />
                                ( {{ items.created_by }} )
                            </td>
                            <td class="text-center">
                                {{ items.problem_name }}
                            </td>
                            <td class="text-center">
                                <v-chip
                                    v-if="items.status == 'open'"
                                    class="ma-2"
                                    color="primary"
                                    text-color="white"
                                    small
                                >
                                    <v-avatar left>
                                        <v-icon>mdi-email-open</v-icon>
                                    </v-avatar>
                                    {{ items.status }}
                                </v-chip>
                                <v-chip
                                    v-if="items.status == 'approve'"
                                    class="ma-2"
                                    color="warning"
                                    text-color="white"
                                    small
                                >
                                    <v-avatar left>
                                        <v-icon>mdi-account-multiple</v-icon>
                                    </v-avatar>
                                    {{ items.status }}
                                </v-chip>
                                <v-chip
                                    v-if="items.status == 'not approve'"
                                    class="ma-2"
                                    color="grey"
                                    text-color="white"
                                    small
                                >
                                    <v-avatar left>
                                        <v-icon>mdi-account-off</v-icon>
                                    </v-avatar>
                                    {{ items.status }}
                                </v-chip>
                                <v-chip
                                    v-if="items.status == 'response'"
                                    class="ma-2"
                                    color="error"
                                    text-color="white"
                                    small
                                >
                                    <v-avatar left>
                                        <v-icon>mdi-account-convert</v-icon>
                                    </v-avatar>
                                    {{ items.status }}
                                </v-chip>
                                <v-chip
                                    v-if="items.status == 'closed'"
                                    class="ma-2"
                                    color="success"
                                    text-color="white"
                                    small
                                >
                                    <v-avatar left>
                                        <v-icon>mdi-close-outline</v-icon>
                                    </v-avatar>
                                    {{ items.status }}
                                </v-chip>
                            </td>

                            <td>{{ items.detail }}</td>

                            <td>
                                <v-btn
                                    v-if="items.status == 'open'"
                                    class="white--text mr-1 ml-1"
                                    color="success"
                                    depressed
                                    x-small
                                    @click="editItem(items)"
                                >
                                    <v-icon dark small>mdi-account-edit</v-icon
                                    >Edit </v-btn
                                >&nbsp;
                                <v-btn
                                    class="white--text mr-1 ml-1"
                                    color="primary"
                                    depressed
                                    x-small
                                    @click="viewItemIt(items)"
                                >
                                    <v-icon dark small>mdi-eye</v-icon
                                    >View </v-btn
                                >&nbsp;
                                <v-btn
                                    v-if="
                                        items.status != 'response' &&
                                        items.status != 'approve' &&
                                        items.status != 'closed'
                                    "
                                    class="white--text mr-1 ml-1"
                                    color="error"
                                    depressed
                                    x-small
                                    @click="delalert(items)"
                                >
                                    <v-icon dark small>mdi-delete</v-icon>Delete
                                </v-btn>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <div class="text-center pb-5 pt-4">
                <div>
                    <v-btn class="mx-2" fab small @click="back()">
                        <v-icon dark small>mdi-chevron-left</v-icon>
                    </v-btn>

                    <v-btn
                        class="mx-2"
                        fab
                        small
                        :color="btn_color(n)"
                        v-for="n in page_count"
                        :key="n"
                        @click="get_it_page(page_num_show(n))"
                        >{{ page_num_show(n) }}</v-btn
                    >

                    <v-btn class="mx-2" fab small @click="next()">
                        <v-icon dark small>mdi-chevron-right</v-icon>
                    </v-btn>
                </div>
            </div>
        </v-card>
    </div>
</template>
<script src="https://kit.fontawesome.com/your-code-number.js"></script>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
export default {
    computed: {
        ...mapState(["isLoading"]),
        formTitle() {
            return this.editedIndex === -1 ? "Open Ticket" : "Edit Ticket"
        },
        dateRangeText() {
            this.form_search.date.sort((a, b) => {
                return new Date(a) - new Date(b)
            })

            return this.form_search.date.join(" ~ ")
        },
    },
    mounted() {
        this.getProblem()
        this.getIt()
        this.getAjax()
    },
    data() {
        const srcs = {
            1: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
            2: "https://cdn.vuetifyjs.com/images/lists/2.jpg",
            3: "https://cdn.vuetifyjs.com/images/lists/3.jpg",
            4: "https://cdn.vuetifyjs.com/images/lists/4.jpg",
            5: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
        }
        return {
            employees: [],
            dateR: [(v) => !!v || "Dates  is required"],
            form_search: {
                date: [],
                search: "",
            },
            modal: false,
            team_name: localStorage.team_name,
            images: "images",
            chip: "chip",
            chip0: true,
            chip1: true,
            chip2: true,
            chip3: true,
            chip4: true,

            sliderTimer: 0,
            showpic: `${process.env.VUE_APP_ROOT_API}/api/it/attachments/`,
            typeapproveh: "",
            typeapprovenameh: "",
            typeapprovename: "",
            typeapprove: "",
            typeviewit: [],
            subtypeviewit: [],
            checkbutton: false,
            checkbuttonsub: false,
            num: 1,
            valid: false,
            validit: false,
            validresponse: false,
            validapprove: false,
            notapproveR: [(v) => !!v || "reason is required"],
            ResponeR: [(v) => !!v || "Remark is required"],
            CauseR: [(v) => !!v || "Cause is required"],
            SolutionR: [(v) => !!v || "Solution is required"],
            TypeitR: [(v) => !!v || "Typeit is required"],
            SeverityR: [(v) => !!v || "Severity is required"],
            ErrorR: [(v) => !!v || "Error is required"],
            SelectApproveR: [(v) => !!v || "Approve is required"],
            DescriptionR: [(v) => !!v || "Description is required"],
            TypeR: [(v) => !!v || "Type is required"],
            SeveritySelect: ["Low", "Medium", "High"],
            TypeSelect: ["Services Request", "Incidents"],
            ReceiptnoR: [(v) => !!v || "ReceiptNo is required"],
            CaseIDR: [(v) => !!v || "CaseID is required"],
            page: 1,
            page_total: 0,
            page_count: 0,
            chk_num_page: 0,
            buttonsub: [
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
            ],
            button: [
                "",
                "button",
                "button",
                "button",
                "button",
                "button",
                "button",
                "button",
                "button",
                "button",
                "button",
                "button",
                "button",
                "button",
                "button",
            ],
            button1: ["", "button2", "button2"],
            button2: ["", "button4", "button4"],
            files: [],
            search: "",
            problems: [],
            data: [],
            datait: [],
            subproblems: [],
            dialogimg: false,
            dialog: false,
            dialogviewit: false,
            editedIndex: -1,
            sentviewItapprove: {
                approve_status: "",
                remark: "",
            },
            sentviewItresponse: {
                remark: "",
                cause: "",
                solution: "",
                files: [],
            },
            viewItem: {},
            sentviewIt: {
                response_status: "",
                approve_id: "",
                error_id: "",
                type: "",
                severity: "",
            },
            editedItem: {
                problem_id: "",
                subproblem_id: "",
                detail: "",
                files: [],
            },
            defaultItem: {
                problem_id: "",
                subproblem_id: "",
                detail: "",
                files: [],
            },
            status_filter: "",
        }
    },

    methods: {
        remove() {
            this.editedItem.created_by = []
        },
        get_date() {
            if (this.dateRangeText.length === 23) {
                this.modal = false
                this.getAjax()
            }
        },
        substr(myarguments) {
            return myarguments.substr(-3)
        },
        ...mapMutations(["mutateIsLoading"]),
        openFile(fileName, idxeditpic) {
            window.open(this.showpic + fileName)
            // console.log(idxeditpic);
        },
        show(id) {
            const vuer = this.$el.querySelector(".images") + id
            vuer.show()
        },
        removepic(item) {
            this.editedItem.images.splice(
                this.editedItem.images.indexOf(item),
                1
            )
        },
        removefiles(item) {
            this.editedItem.files.splice(this.editedItem.files.indexOf(item), 1)
        },
        showimg() {
            this.dialogimg = true
        },
        cancelimg() {
            this.dialogimg = false
        },

        resetEdited() {
            this.editedItem = { ...this.defaultItem }
            this.editedIndex = -1
        },
        // async sentpicture(file_store_name) {
        //   let url = `${process.env.VUE_APP_ROOT_API}/api/it/attachments/${file_store_name}`;
        //   this.showpic = url;
        // },
        // mouseOver: function() {
        //   // alert(this.active);
        //   if (this.active) {
        //     this.active = false;
        //     this.color = "color:black;background:white;";
        //     this.button = "button";
        //   } else {
        //     this.active = true;
        //     this.button = "button button5";
        //     this.color = "color:white;background:black;";
        //   }
        // },
        // mouseLeave: function() {
        //   // alert(this.active);
        //   if (this.active) {
        //     this.active = false;
        //     this.color = "color:black;";
        //     this.button = "button";
        //   } else {
        //     this.active = false;
        //     this.color = "color:black;";
        //     this.button = "button button5";
        //   }
        // },

        selectedn(e) {
            this.button1 = [
                "",
                "button2",
                "button2",
                "button2",
                "button2",
                "button2",
                "button2",
                "button2",
                "button2",
                "button2",
                "button2",
                "button2",
                "button2",
                "button2",
            ]
            this.button1[e] = "button3"
            this.typeapprove = e
            setTimeout(() => {
                this.$refs.formviewit.validate()
            }, 100)
        },
        selectedsubname(index) {
            this.buttonsub = [
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
            ]
            this.editedItem.subproblem_id = index
            this.buttonsub[index] = "buttonsub1"
            this.checkbuttonsub = true
        },
        selected1(e) {
            this.button2 = [
                "",
                "button4",
                "button4",
                "button4",
                "button4",
                "button4",
                "button4",
                "button4",
                "button4",
                "button4",
                "button4",
                "button4",
                "button4",
                "button4",
            ]
            this.button2[e] = "button5"
            this.typeapproveh = e
        },
        selected(e) {
            this.checkbutton = true
            this.checkbuttonsub = false
            this.editedItem.problem_id = e
            if (this.editedIndex == "-1") {
                this.editedItem.subproblem_id = ""
            }
            this.getSubProblem()
            this.editedItem.subproblem_id = ""
            if (
                this.editedItem.problem_id == "1" ||
                this.editedItem.problem_id == "2"
            ) {
                this.editedItem.subproblem_id = ""
            }
            this.button = [
                "",
                "button",
                "button",
                "button",
                "button",
                "button",
                "button",
                "button",
                "button",
                "button",
                "button",
                "button",
                "button",
                "button",
            ]
            this.button[e] = "button1"

            // if (this.editedItem.problem_id == "1") {
            //   this.button1 = "button1";
            //   this.button2 = "button";
            //   this.button3 = "button";
            //   this.button4 = "button";
            //   this.button5 = "button";
            // }
            // if (this.editedItem.problem_id == "2") {
            //   this.button1 = "button";
            //   this.button2 = "button1";
            //   this.button3 = "button";
            //   this.button4 = "button";
            //   this.button5 = "button";
            // }
            // if (this.editedItem.problem_id == "3") {
            //   this.button1 = "button";
            //   this.button2 = "button";
            //   this.button3 = "button1";
            //   this.button4 = "button";
            //   this.button5 = "button";
            // }
            // if (this.editedItem.problem_id == "4") {
            //   this.button1 = "button";
            //   this.button2 = "button";
            //   this.button3 = "button";
            //   this.button4 = "button1";
            //   this.button5 = "button";
            // }
            // if (this.editedItem.problem_id == "5") {
            //   this.button1 = "button";
            //   this.button2 = "button";
            //   this.button3 = "button";
            //   this.button4 = "button";
            //   this.button5 = "button1";
            // }
        },
        newItem() {
            this.resetEdited()
            this.getEmployee()
            this.files = []
            this.editedItem.problem_id = ""
            this.editedItem.subproblem_id = ""
            this.editedItem.detail = ""
            this.button[0] = "button"
            this.button[1] = "button"
            this.button[2] = "button"
            this.button[3] = "button"
            this.button[4] = "button"
            this.button[5] = "button"
            this.button[6] = "button"
            this.button[7] = "button"
            this.button[8] = "button"
            this.button[9] = "button"
            this.button[10] = "button"
            this.button[11] = "button"
            this.button[12] = "button"
            this.button[13] = "button"
            this.checkbutton = false
            this.checkbuttonsub = false
            ;(this.buttonsub = [
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
                "buttonsub",
            ]),
                (this.dialog = true)
            setTimeout(() => {
                this.$refs.form.validate()
            }, 100)
        },
        async getEmployee() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/employees`
            try {
                const { data } = await axios.get(url)
                this.employees = []
                // console.log(data, "hhh");
                this.employees = data
            } catch (error) {
                console.log(error)
            }
        },
        editItem(item) {
            console.log(item, "test")
            this.files = []
            this.editedIndex = item.ticket_id
            this.selected(item.problem_id)
            this.getEmployee()
            item.status1 = item.status1 == 1 ? true : false
            this.editedItem = []
            this.editedItem = Object.assign({}, item)
            this.selectedsubname(this.editedItem.subproblem_id)
            this.dialog = true
        },

        async viewItemIt(item) {
            this.sentviewItresponse.remark = ""
            this.sentviewItresponse.solution = ""
            this.sentviewItresponse.cause = ""
            this.sentviewIt.approve_id = ""
            this.sentviewIt.severity = ""
            this.sentviewIt.type = ""
            this.button1 = ["", "button2", "button2"]
            ;(this.button2 = ["", "button4", "button4"]),
                (this.sentviewIt.error_id = "")
            this.sentviewItresponse.files = []
            this.viewItem = item
            // console.log(this.viewItem, "ddd")
            this.typeapprove = ""
            this.typeapprovename = ""
            this.dialogviewit = true
            setTimeout(() => {
                this.$refs.formviewit.validate()
            }, 100)
            this.getTypeIt(item.ticket_id)
        },
        delalert(item) {
            this.$swal({
                title: "Are you sure you want to delete ?",
                text: "",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((del) => {
                if (del) {
                    if (this.deleteItem(item)) {
                        swal({
                            title: "Delete Complete",
                            icon: "success",
                            button: "OK",
                        })
                    }
                } else {
                }
            })
        },
        async deleteItem(item) {
            const idx = item.ticket_id
            const url = `${process.env.VUE_APP_ROOT_API}/api/it`
            try {
                const { data } = await axios.delete(url + "/" + idx)
            } catch (error) {
                console.log(error)
            }
            this.getAjax()
        },
        deletepic(pic, pic1, item) {
            this.$swal({
                title: "Are you sure you want to delete ?",
                text: "",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((del) => {
                if (del) {
                    if (this.deletepic1(pic, pic1, item)) {
                        swal({
                            title: "Delete Complete",
                            icon: "success",
                            button: "OK",
                        })
                        setTimeout(() => {
                            this.getAjax()
                        }, 1000)
                    }
                } else {
                }
            })
        },
        async deletepic1(pic, pic1, item) {
            const idx = pic
            const url = `${process.env.VUE_APP_ROOT_API}/api/it/attachments`
            try {
                const { data } = await axios.delete(url + "/" + idx)
                this.removepic(item)
            } catch (error) {
                console.log(error)
            }

            // this.getAjax();

            // this.dialog = false;

            // this.editItem(pic1);
        },
        deletefiles(pic, pic1, item) {
            this.$swal({
                title: "Are you sure you want to delete ?",
                text: "",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((del) => {
                if (del) {
                    if (this.deletefiles1(pic, pic1, item)) {
                        swal({
                            title: "Delete Complete",
                            icon: "success",
                            button: "OK",
                        })
                        setTimeout(() => {
                            this.getAjax()
                        }, 1000)
                    }
                } else {
                }
            })
        },
        async deletefiles1(pic, pic1, item) {
            const idx = pic
            const url = `${process.env.VUE_APP_ROOT_API}/api/it/attachments`
            try {
                const { data } = await axios.delete(url + "/" + idx)
                this.removefiles(item)
            } catch (error) {
                console.log(error)
            }

            // this.getAjax();

            // this.dialog = false;
            // console.log(this.dialog);
            // this.editItem(pic1);
        },
        onFileSelected(event) {
            if (this.editedItem.files.length == 0) {
                this.editedItem.files = Array()
            }
            for (let i = 0; i < event.length; i++) {
                this.editedItem.files.push(event[i])
            }
        },
        close() {
            this.dialog = false
            setTimeout(() => {
                this.resetEdited()
            }, 300)
        },
        closeviewit() {
            this.dialogviewit = false
            setTimeout(() => {
                this.resetEdited()
            }, 300)
        },
        save() {
            this.editedItem.status1 = this.editedItem.status1 === true ? 1 : 0
            if (
                this.editedItem.case_id == undefined ||
                this.editedItem.case_id == ""
            ) {
                this.editedItem.case_id = ""
            }
            if (
                this.editedItem.receipt_no == undefined ||
                this.editedItem.receipt_no == ""
            ) {
                this.editedItem.receipt_no = ""
            }
            if (
                this.editedItem.created_by == undefined ||
                this.editedItem.created_by == ""
            ) {
                this.editedItem.created_by = ""
            }
            this.sendAjax(this.editedItem, this.editedIndex)
            this.close()
        },
        saveit() {
            this.editedIndex = this.viewItem.ticket_id
            this.sendviewIt(this.sentviewIt, this.editedIndex)
            this.dialogviewit = false
        },
        saveitapprove() {
            this.editedIndex = this.viewItem.ticket_id
            this.sendviewItapprove(
                this.sentviewItapprove,
                this.editedIndex,
                "approve and respone"
            )
            this.dialogviewit = false
        },
        saveitresponse() {
            this.editedIndex = this.viewItem.ticket_id
            this.sendviewItapprove(
                this.sentviewItresponse,
                this.editedIndex,
                "response"
            )
            this.dialogviewit = false
        },
        async sendviewItapprove(item, idx, status) {
            if (status == "approve and respone") {
                if (this.typeapproveh == "1") {
                    this.sentviewItapprove.approve_status = "approve"
                } else if (this.typeapproveh == "2") {
                    this.sentviewItapprove.approve_status = "notapprove"
                }
                // console.log(item, "itemsx");
                const url = `${process.env.VUE_APP_ROOT_API}/api/it`
                // console.log(item, "item", idx, "idx");
                var res = idx.substr(-1)
                const options = {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                    },
                }
                if (res > -1) {
                    try {
                        const { data } = await axios.post(
                            url + "/" + this.editedIndex,
                            item,
                            options
                        )

                        // console.log(idx, "edit");
                    } catch (error) {
                        console.log(error)
                    }
                }
            } else if (status == "response") {
                const url = `${process.env.VUE_APP_ROOT_API}/api/it`
                // console.log(item, "item", idx, "idx");
                var res = idx.substr(-1)
                const options = {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                        "Content-Type": "multipart/form-data",
                    },
                }
                if (res > -1) {
                    try {
                        let formData = new FormData()
                        formData.append("remark", item.remark)
                        formData.append("cause", item.cause)
                        formData.append("solution", item.solution)
                        formData.append("files", item.files)

                        if (undefined !== item.files && item.files.length) {
                            for (let i = 0; i < item.files.length; i++) {
                                formData.append(`files[${i}]`, item.files[i])
                            }
                        }
                        const { data } = await axios.post(
                            url + "/" + this.editedIndex,
                            formData,
                            options
                        )

                        // console.log(idx, "edit");
                    } catch (error) {
                        console.log(error)
                    }
                }
            }
            this.getAjax()
        },
        async sendviewIt(item, idx) {
            if (this.typeapprove == "1") {
                this.sentviewIt.response_status = "approve"
            } else if (this.typeapprove == "2") {
                this.sentviewIt.response_status = "response"
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/it`
            // console.log(item, "item", idx, "idx")
            var res = idx.substr(-1)
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            if (res > -1) {
                try {
                    const { data } = await axios.post(
                        url + "/" + this.editedIndex,
                        item,
                        options
                    )
                    // console.log(idx, "edit");
                } catch (error) {
                    console.log(error)
                }
            }
            this.getAjax()
        },
        async sendAjax(item, idx) {
            this.mutateIsLoading()
            const url = `${process.env.VUE_APP_ROOT_API}/api/it/new-ticket`
            if (idx == -1) {
                var res = "-1"
            } else {
                var res = idx.substr(-1)
            }

            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                    "Content-Type": "multipart/form-data",
                },
            }

            if (res > -1) {
                try {
                    let formData = new FormData()
                    formData.append("problem_id", item.problem_id)
                    formData.append("subproblem_id", item.subproblem_id)
                    formData.append("detail", item.detail)
                    formData.append("receipt_no", item.receipt_no)
                    formData.append("case_id", item.case_id)
                    formData.append("created_by", item.created_by)
                    if (
                        undefined !== this.editedItem.files &&
                        this.editedItem.files.length
                    ) {
                        for (let i = 0; i < this.editedItem.files.length; i++) {
                            formData.append(
                                `files[${i}]`,
                                this.editedItem.files[i]
                            )
                        }
                    }
                    const { data } = await axios.post(
                        url + "/" + this.editedIndex,
                        formData,
                        options
                    )
                    this.mutateIsLoading()
                } catch (error) {
                    console.log(error)
                }
            } else {
                try {
                    let formData = new FormData()
                    formData.append("problem_id", item.problem_id)
                    formData.append("subproblem_id", item.subproblem_id)
                    formData.append("detail", item.detail)
                    formData.append("receipt_no", item.receipt_no)
                    formData.append("case_id", item.case_id)
                    formData.append("created_by", item.created_by)
                    if (
                        undefined !== this.editedItem.files &&
                        this.editedItem.files.length
                    ) {
                        for (let i = 0; i < this.editedItem.files.length; i++) {
                            formData.append(
                                `files[${i}]`,
                                this.editedItem.files[i]
                            )
                        }
                    }
                    const { data } = await axios.post(url, formData, options)
                    this.mutateIsLoading()
                } catch (error) {
                    console.log(error)
                }
            }
            this.getAjax()
        },
        async getIt() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/it/get-form-request`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                this.mutateIsLoading()

                const { data } = await axios.get(url, options)
                this.datait = data

                this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        },
        async getAjax() {
            this.mutateIsLoading()
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const sent = {
                status: this.status_filter,
                date: this.form_search.date,
                search: this.form_search.search,
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/it`
            try {
                const { data } = await axios.post(url, sent, options)
                this.data = data

                this.mutateIsLoading()
                this.page_total = data.last_page
                this.page_total < 7
                    ? (this.page_count = this.page_total)
                    : (this.page_count = 7)
                // console.log(this.data, "22");
            } catch (error) {
                console.log(error)
            }
        },
        searchProject(value) {
            this.status_filter = value
            this.getAjax()
            // let url = `${process.env.VUE_APP_ROOT_API}/api/it?status=`
            // let { data } = await axios.get(url + value)

            // this.data = data
            // this.page_total = data.last_page
            // this.page_total < 7
            //     ? (this.page_count = this.page_total)
            //     : (this.page_count = 7)
        },
        async back() {
            const sent = {
                status: this.status_filter,
                date: this.form_search.date,
                search: this.form_search.search,
            }
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let url = this.data.prev_page_url
            let { data } = await axios.post(url, sent, options)
            this.data = data
        },
        async next() {
            const sent = {
                status: this.status_filter,
                date: this.form_search.date,
                search: this.form_search.search,
            }
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let url = this.data.next_page_url
            let { data } = await axios.post(url, sent, options)
            this.data = data
        },
        async get_it_page(num) {
            const sent = {
                status: this.status_filter,
                date: this.form_search.date,
                search: this.form_search.search,
            }
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            if (num != "...") {
                this.current_page = num
                let url = `${process.env.VUE_APP_ROOT_API}/api/it?page=` + num
                let { data } = await axios.post(url, sent, options)
                this.data = data
            }
        },
        btn_color(n) {
            if (this.page_count == 7) {
                if (this.data.current_page <= 4) {
                    return this.data.current_page === n ? "primary" : ""
                } else if (this.data.current_page == this.data.last_page) {
                    return n === 7 ? "primary" : ""
                } else if (this.data.current_page == this.data.last_page - 1) {
                    return n === 6 ? "primary" : ""
                } else if (this.data.current_page == this.data.last_page - 2) {
                    return n === 5 ? "primary" : ""
                } else {
                    return n === 4 ? "primary" : ""
                }
            } else {
                return this.data.current_page === n ? "primary" : ""
            }
        },
        page_num_show(n) {
            let page = n
            if (this.page_count == 7) {
                let chk2 = 0
                let chk3 = 0
                let chk4 = 0
                let chk5 = 0
                let chk6 = 0
                if (this.data.current_page == 1) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data.last_page - 1
                } else if (this.data.current_page == this.data.last_page) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data.last_page - 3
                    chk5 = this.data.last_page - 2
                    chk6 = this.data.last_page - 1
                } else if (this.data.current_page == 2) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data.last_page - 1
                } else if (this.data.current_page == this.data.last_page - 1) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data.last_page - 3
                    chk5 = this.data.last_page - 2
                    chk6 = this.data.last_page - 1
                } else if (this.data.current_page == 3) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data.last_page - 1
                } else if (this.data.current_page == this.data.last_page - 2) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data.last_page - 3
                    chk5 = this.data.last_page - 2
                    chk6 = this.data.last_page - 1
                } else {
                    chk2 = "..."
                    chk3 = this.data.current_page - 1
                    chk4 = this.data.current_page
                    chk5 = this.data.current_page + 1
                    chk6 = "..."
                }

                n === 1 ? (page = 1) : ""
                n === 2 ? (page = chk2) : ""
                n === 3 ? (page = chk3) : ""
                n === 4 ? (page = chk4) : ""
                n === 5 ? (page = chk5) : ""
                n === 6 ? (page = chk6) : ""
                n === 7 ? (page = this.data.last_page) : ""
            } else {
                n === 1 ? (page = 1) : ""
                n === 2 ? (page = 2) : ""
                n === 3 ? (page = 3) : ""
                n === 4 ? (page = 4) : ""
                n === 5 ? (page = 5) : ""
                n === 6 ? (page = 6) : ""
            }
            return page
        },
        async getProblem() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/it/get-form-request`
            this.tk = {
                headers: { Authorization: "Bearer " + localStorage.token },
            }
            try {
                this.mutateIsLoading()

                const { data } = await axios.get(url, this.tk)
                this.problems = data

                this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        },
        async getSubProblem() {
            this.problems.map((each) => {
                try {
                    // console.log(this.problems, "editproblem_id");
                    // console.log(each.problem_id, "problems.problem_id");
                    if (each.problem_id == this.editedItem.problem_id) {
                        this.subproblems = [...each.subproblem]
                    }
                } catch (error) {
                    console.log(error)
                }
            })
        },
        async getTypeIt(ticket) {
            const url = `${process.env.VUE_APP_ROOT_API}/api/it/` + ticket

            try {
                this.mutateIsLoading()
                const { data } = await axios.get(url)
                this.typeviewit = data
                // console.log(this.typeviewit, "ass");
                this.getSubTypeIt()
                this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        },
        getSubTypeIt() {
            this.typeviewit.error_list
        },
    },
}
</script>

<style scoped>
.button2 {
    background-color: #f4f5f4; /* Green  */
    border: 1px solid #2f6e8d;
    color: rgb(8, 7, 7);
    padding: 10px 20px;

    width: 175px;
    cursor: pointer;

    /* margin: 4px 2px; */
}
.button3 {
    background-color: #f4f5f4; /* Green */
    color: rgb(8, 7, 7);
    padding: 10px 20px;
    border: 1px solid #2f6e8d;
    display: inline-block;

    cursor: pointer;
    width: 175px;
    background-color: #555555;
    color: white;

    /* margin: 4px 2px; */
}
.button4 {
    background-color: #f4f5f4; /* Green  */
    border: 1px solid #2f6e8d;
    color: rgb(8, 7, 7);
    padding: 10px 20px;

    width: 175px;
    cursor: pointer;

    /* margin: 4px 2px; */
}
.button5 {
    background-color: #f4f5f4; /* Green */
    color: rgb(8, 7, 7);
    padding: 10px 20px;
    border: 1px solid #2f6e8d;
    display: inline-block;

    cursor: pointer;
    width: 175px;
    background-color: #555555;
    color: white;

    /* margin: 4px 2px; */
}

@media screen and (min-width: 280px) {
    /* iphonese:5 */
    .buttonsub {
        background-color: #f4f5f4; /* Green  */
        margin-left: 30px;
        color: rgb(8, 7, 7);
        padding: 20px 40px;
        text-align: center;

        cursor: pointer;

        border-radius: 15px;

        /* margin: 4px 2px; */
    }
    .buttonsub1 {
        margin-left: 30px;
        background-color: #40c440; /* Green */
        color: rgb(8, 7, 7);
        padding: 20px 40px;

        display: inline-block;

        cursor: pointer;

        border-radius: 15px;

        color: white;
        /* margin: 4px 2px; */
    }
    .button {
        margin-left: 30px;
        background-color: #f4f5f4; /* Green  */

        color: rgb(8, 7, 7);
        padding: 20px 40px;
        text-align: center;

        cursor: pointer;

        border-radius: 15px;

        /* margin: 4px 2px; */
    }
    .button1 {
        background-color: #f4f5f4; /* Green */
        color: rgb(8, 7, 7);
        padding: 20px 40px;
        margin-left: 30px;
        display: inline-block;

        cursor: pointer;

        border-radius: 15px;
        background-color: #555555;
        color: white;

        /* margin: 4px 2px; */
    }
    h2 {
        display: block;
        font-size: 12px;
        margin-top: 0.83em;
        margin-bottom: 0.83em;
        margin-left: 0;
        margin-right: 0;
    }
}
@media screen and (min-width: 320px) {
    /* iphonese:5 */
    .buttonsub {
        margin-left: 5px;
        background-color: #f4f5f4; /* Green  */

        color: rgb(8, 7, 7);
        padding: 10px 20px;
        text-align: center;

        cursor: pointer;

        border-radius: 15px;

        /* margin: 4px 2px; */
    }
    .buttonsub1 {
        margin-left: 5px;
        background-color: #f4f5f4; /* Green */
        color: rgb(8, 7, 7);
        padding: 10px 20px;

        display: inline-block;

        cursor: pointer;

        border-radius: 15px;
        background-color: #555555;
        color: white;
        /* margin: 4px 2px; */
    }
    .button {
        margin-left: 5px;
        background-color: #f4f5f4; /* Green  */

        color: rgb(8, 7, 7);
        padding: 16px 32px;
        text-align: center;

        cursor: pointer;

        border-radius: 15px;

        /* margin: 4px 2px; */
    }
    .button1 {
        margin-left: 5px;
        background-color: #f4f5f4; /* Green */
        color: rgb(8, 7, 7);
        padding: 16px 32px;

        display: inline-block;

        cursor: pointer;

        border-radius: 15px;
        background-color: #555555;
        color: white;

        /* margin: 4px 2px; */
    }

    h2 {
        display: block;
        font-size: 12px;
        margin-top: 0.83em;
        margin-bottom: 0.83em;
        margin-left: 0;
        margin-right: 0;
    }
}
@media screen and (min-width: 360px) {
    /* iphonese:5 */
    .buttonsub {
        margin-left: 15px;
        background-color: #f4f5f4; /* Green  */

        color: rgb(8, 7, 7);
        padding: 18px 36px;
        text-align: center;

        cursor: pointer;

        border-radius: 15px;

        /* margin: 4px 2px; */
    }
    .buttonsub1 {
        margin-left: 15px;
        background-color: #40c440; /* Green */
        color: rgb(8, 7, 7);
        padding: 18px 36px;

        display: inline-block;

        cursor: pointer;

        border-radius: 15px;

        color: white;
        /* margin: 4px 2px; */
    }
    .button {
        margin-left: 15px;
        background-color: #f4f5f4; /* Green  */

        color: rgb(8, 7, 7);
        padding: 18px 36px;
        text-align: center;

        cursor: pointer;

        border-radius: 15px;

        /* margin: 4px 2px; */
    }
    .button1 {
        margin-left: 15px;
        background-color: #f4f5f4; /* Green */
        color: rgb(8, 7, 7);
        padding: 18px 36px;

        display: inline-block;

        cursor: pointer;

        border-radius: 15px;
        background-color: #555555;
        color: white;

        /* margin: 4px 2px; */
    }
    h2 {
        display: block;
        font-size: 12px;
        margin-top: 0.83em;
        margin-bottom: 0.83em;
        margin-left: 0;
        margin-right: 0;
    }
}
@media screen and (min-width: 375px) {
    /* iphone 678:X XS*/
    .button {
        margin-left: 7px;
        background-color: #f4f5f4; /* Green  */

        color: rgb(8, 7, 7);
        padding: 22px 44px;
        text-align: center;

        cursor: pointer;

        border-radius: 15px;

        /* margin: 4px 2px; */
    }
    .button1 {
        margin-left: 7px;
        background-color: #f4f5f4; /* Green */
        color: rgb(8, 7, 7);
        padding: 22px 44px;

        display: inline-block;

        cursor: pointer;

        border-radius: 15px;
        background-color: #555555;
        color: white;

        /* margin: 4px 2px; */
    }
    h2 {
        display: block;
        font-size: 12px;
        margin-top: 0.83em;
        margin-bottom: 0.83em;
        margin-left: 0;
        margin-right: 0;
    }
}
@media screen and (min-width: 411px) {
    /* Pixel XL*/
    .buttonsub {
        margin-left: 2px;
        background-color: #f4f5f4; /* Green  */

        color: rgb(8, 7, 7);
        padding: 16px 32px;
        text-align: center;

        cursor: pointer;

        border-radius: 15px;

        /* margin: 4px 2px; */
    }
    .buttonsub1 {
        margin-left: 2px;
        background-color: #40c440; /* Green */
        color: rgb(8, 7, 7);
        padding: 16px 32px;

        display: inline-block;

        cursor: pointer;

        border-radius: 15px;

        color: white;
        /* margin: 4px 2px; */
    }
    .button {
        margin-left: 2px;
        background-color: #f4f5f4; /* Green  */

        color: rgb(8, 7, 7);
        padding: 16px 32px;
        text-align: center;

        cursor: pointer;

        border-radius: 15px;

        /* margin: 4px 2px; */
    }
    .button1 {
        margin-left: 2px;
        background-color: #f4f5f4; /* Green */
        color: rgb(8, 7, 7);
        padding: 16px 32px;

        display: inline-block;

        cursor: pointer;

        border-radius: 15px;
        background-color: #555555;
        color: white;

        /* margin: 4px 2px; */
    }
    h2 {
        display: block;
        font-size: 12px;
        margin-top: 0.83em;
        margin-bottom: 0.83em;
        margin-left: 0;
        margin-right: 0;
    }
}
@media screen and (min-width: 414px) {
    /* iphone 678 plus*/
    .button {
        margin-left: 0px;
        background-color: #f4f5f4; /* Green  */

        color: rgb(8, 7, 7);
        padding: 17px 34px;
        text-align: center;

        cursor: pointer;

        border-radius: 15px;

        /* margin: 4px 2px; */
    }
    .button1 {
        margin-left: 0px;
        background-color: #f4f5f4; /* Green */
        color: rgb(8, 7, 7);
        padding: 17px 34px;

        display: inline-block;

        cursor: pointer;

        border-radius: 15px;
        background-color: #555555;
        color: white;

        /* margin: 4px 2px; */
    }
    h2 {
        display: block;
        font-size: 12px;
        margin-top: 0.83em;
        margin-bottom: 0.83em;
        margin-left: 0;
        margin-right: 0;
    }
}

@media screen and (min-width: 600px) {
    .button {
        margin-left: 0px;
        background-color: #f4f5f4; /* Green */

        color: rgb(8, 7, 7);
        padding: 14px 28px;
        text-align: center;
        text-decoration: none;
        display: inline-block;

        transition-duration: 0.4s;
        cursor: pointer;

        border-radius: 15px;

        /* margin: 4px 2px; */
    }
    .button1 {
        margin-left: 0px;
        background-color: #f4f5f4; /* Green */
        color: rgb(8, 7, 7);
        padding: 14px 28px;
        text-align: center;
        text-decoration: none;
        display: inline-block;

        transition-duration: 0.4s;
        cursor: pointer;

        border-radius: 15px;
        background-color: #555555;
        color: white;

        /* margin: 4px 2px; */
    }
    h2 {
        display: block;
        font-size: 12px;
        margin-top: 0.83em;
        margin-bottom: 0.83em;
        margin-left: 0;
        margin-right: 0;
    }
}
@media screen and (min-width: 768px) {
    .buttonsub {
        margin-left: 0px;
        background-color: #f4f5f4; /* Green */
        color: rgb(8, 7, 7);
        padding: 4px 8px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 16px;

        transition-duration: 0.4s;
        cursor: pointer;
        border: 2px dotted #138522;
        border-radius: 50%;
        height: 75px;
        width: 100px;

        /* margin: 4px 2px; */
    }
    .buttonsub1 {
        margin-left: 0px;
        color: rgb(8, 7, 7);
        padding: 4px 8px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 16px;
        transition-duration: 0.4s;
        cursor: pointer;
        border: 2px dotted #138522;
        border-radius: 50%;
        background-color: #40c440;
        color: white;
        height: 75px;
        width: 100px;
        /* margin: 4px 2px; */
    }
    .button {
        margin-left: 0px;
        background-color: #f4f5f4; /* Green */

        color: rgb(8, 7, 7);
        padding: 16px 32px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 16px;

        transition-duration: 0.4s;
        cursor: pointer;
        border: 3px solid #2f6e8d;
        border-radius: 15px;
        height: 75px;
        width: 100px;
        /* margin: 4px 2px; */
    }
    .button1 {
        margin-left: 0px;
        background-color: #f4f5f4; /* Green */
        color: rgb(8, 7, 7);
        padding: 16px 32px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 16px;
        transition-duration: 0.4s;
        cursor: pointer;
        border: 3px solid #2f6e8d;
        border-radius: 15px;
        background-color: #555555;
        color: white;
        height: 75px;
        width: 100px;
        /* margin: 4px 2px; */
    }
    h2 {
        display: block;
        font-size: 1.5em;
        margin-top: 0.83em;
        margin-bottom: 0.83em;
        margin-left: 0;
        margin-right: 0;
        font-weight: bold;
    }
    .status1 {
        display: inline;
    }
}
@media screen and (min-width: 1024px) {
    .buttonsub {
        margin-left: 0px;
        background-color: #f4f5f4; /* Green */
        color: rgb(8, 7, 7);
        padding: 4px 8px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 16px;

        transition-duration: 0.4s;
        cursor: pointer;
        border: 2px dotted #138522;
        border-radius: 50%;
        height: 75px;
        width: 100px;

        /* margin: 4px 2px; */
    }
    .buttonsub1 {
        margin-left: 0px;
        color: rgb(8, 7, 7);
        padding: 4px 8px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 16px;
        transition-duration: 0.4s;
        cursor: pointer;
        border: 2px dotted #138522;
        border-radius: 50%;
        background-color: #40c440;
        color: white;
        height: 75px;
        width: 100px;
        /* margin: 4px 2px; */
    }
    .button {
        background-color: #f4f5f4; /* Green */
        margin-left: 0px;
        color: rgb(8, 7, 7);
        padding: 16px 32px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 16px;

        transition-duration: 0.4s;
        cursor: pointer;
        border: 3px solid #2f6e8d;
        border-radius: 15px;
        height: 75px;
        width: 100px;
        /* margin: 4px 2px; */
    }
    .button1 {
        margin-left: 0px;
        background-color: #f4f5f4; /* Green */
        color: rgb(8, 7, 7);
        padding: 16px 32px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 16px;
        transition-duration: 0.4s;
        cursor: pointer;
        border: 3px solid #2f6e8d;
        border-radius: 15px;
        background-color: #555555;
        color: white;
        height: 75px;
        width: 100px;
        /* margin: 4px 2px; */
    }
    h2 {
        display: block;
        font-size: 1.5em;
        margin-top: 0.83em;
        margin-bottom: 0.83em;
        margin-left: 0;
        margin-right: 0;
        font-weight: bold;
    }
    .status {
        padding-left: 70px;
    }
    .status1 {
        display: none;
    }
}

.button:hover {
    background-color: #f8fce3; /* Green */
}
.buttonsub:hover {
    background-color: #c1ebcf; /* Green */
}
.topright {
    position: absolute;
    top: 8px;
    right: 16px;
    font-size: 18px;
}
</style>
